export default {
  options: {
    none: 'Pas de code promo pour commencer',
  },
  buttons: {
    next: 'Suivant',
    back: 'Retour',
    skip: 'Passer',
  },
};
